import { createContext } from "react";

export const DraftContext = createContext();